import "core-js/modules/es7.array.includes.js";
import LinksNewsletter from './LinksNewsletter/LinksNewsletter.vue';
import MentionsLanguage from './MentionsLanguage/MentionsLanguage.vue';
import PaymentSocials from './PaymentSocials/PaymentSocials.vue';
import Reinsurance from './Reinsurance/Reinsurance.vue';
import footerQuery from '~/graphql/footer.gql';
export default {
  name: 'TheFooter',
  components: {
    LinksNewsletter,
    PaymentSocials,
    MentionsLanguage,
    Reinsurance
  },
  props: {
    locale: {
      type: Object,
      default() {
        return {
          market: '',
          language: ''
        };
      }
    }
  },
  data() {
    return {
      routesOnNavModificationsExept: ['market-language']
    };
  },
  computed: {
    isCurrentRouteNeedsSEOOptimisation() {
      return !this.routesOnNavModificationsExept.includes(this.$route.name);
    }
  },
  apollo: {
    footer: {
      query: footerQuery,
      variables() {
        return {
          locale: this.locale.iso
        };
      }
    }
  }
};